import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { reopenAppointment } from '@modules/genetic-counseling/services';
import { PATIENT_PROFILE_QUERY_KEY, REOPEN_APPOINTMENT_QUERY_KEY } from '../constants';
import { ReopenAppointmentFormValues, ReopenAppointmentResponseValues } from '../types/reopen-appointment';

function useMutationReopenAppointment(
  onSuccess: (data: ReopenAppointmentResponseValues) => void,
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const queryClient = useQueryClient();

  const mutationFn = async ({ id }: ReopenAppointmentFormValues): Promise<any> => {
    return await reopenAppointment(id);
  };

  const onMutateFn = async (): Promise<any> => {};

  const onErrorFn = (err: unknown, _id: string, _context: ReopenAppointmentFormValues | undefined): void => {
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {};

  const onSuccessFn = async (
    data: any,
    variables: ReopenAppointmentFormValues,
    _context: ReopenAppointmentFormValues,
  ): Promise<void> => {
    if (variables.id === data.appointmentID) {
      void queryClient.invalidateQueries([PATIENT_PROFILE_QUERY_KEY]);
    }

    onSuccess?.(data);
  };

  return useMutation<any, unknown, any, any>([REOPEN_APPOINTMENT_QUERY_KEY], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
  });
}

export default useMutationReopenAppointment;
